module.exports = __webpack_public_path__ + "images/TickIcon4dc5080253a050c0678715993de9e522.png";